<template>
  <div id="app">
    <b-navbar toggleable="md" type="white" variant="" class="border-bottom">
      <b-navbar-brand to="/">
        <b-img :src="logo" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse">
        <template #default="{ expanded }">
          <b-icon class="text-purple" v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon class="text-purple" v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-item-dropdown text="Catálogo" right>
            <b-dropdown-item v-for="category in categories.docs" v-bind:key="category.slug" :to="'/catalog/' + category.slug">
              {{ category.name }}
            </b-dropdown-item>
          </b-nav-item-dropdown> -->
          <b-nav-item class="text-muted" to="/contact">Contacto</b-nav-item>
          <!-- <b-nav-item class="text-purple" v-b-toggle.sidebar-car>
            <font-awesome-icon :icon="['fas', 'shopping-cart']"/>
            <b-badge pill>{{ itemsInCart.length }}</b-badge>
          </b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view/>
    <b-container fluid class="border-top pt-3">
      <b-row>
        <b-col cols="12" sm="12" md="3" lg="3" xl="3" offset-md="2" offset-lg="2" offset-xl="2">
          <h3 class="text-muted">Sobre nosotros</h3>
          <ul class="list-unstyled">
            <li><b-link to="/">Home</b-link></li>
            <li><b-link to="/about">Nosotros</b-link></li>
            <li><b-link to="/contact">Contacto</b-link></li>
          </ul>
        </b-col>
        <!-- <b-col>
          <h3 class="text-muted">Catálogo</h3>
          <ul class="list-unstyled">
            <li v-for="category in categories.docs" v-bind:key="category.slug">
              <b-link :to="'/catalog/' + category.slug">{{ category.name }}</b-link>
            </li>
          </ul>
        </b-col> -->
        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
          <h3 class="text-muted">Información</h3>
          <ul class="list-unstyled">
            <li><b-link to="/faq">Preguntas frecuentes</b-link></li>
            <li><b-link to="/tos">Términos</b-link></li>
            <li><b-link to="/warranty">Garantía</b-link></li>
          </ul>
        </b-col>
        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
          <h3 class="text-muted">Síguenos</h3>
          <ul class="list-unstyled ml-5">
            <li><b-link class="text-primary" href="https://facebook.com/pamelamolinajoyeria">
              <font-awesome-icon :icon="['fab', 'facebook-square']" size="2x"/>
            </b-link></li>
            <li><b-link href="https://instagram.com/pamelamolinajoyeria">
              <font-awesome-icon :icon="['fab', 'instagram-square']" size="2x"/>
            </b-link></li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-nav>
        <b-nav-text>{{ year }} Pamela Molina - Joyería</b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <Cart :items="itemsInCart"/>
    <b-overlay :show="overlay" rounded="sm" fixed no-wrap />
  </div>
</template>

<script>
import Cart from '@/components/Cart'

export default {
  name: 'App',
  components: { Cart },
  // async mounted () {
  //  window.Mercadopago.setPublishableKey(process.env.VUE_APP_MERCADOPAGO_PUBLIC_KEY)
  //  const request = await this.$http.get('/categories')
  //  this.categories = request.data
  //  this.overlay = false
  // },
  computed: {
    itemsInCart () {
      return this.$store.state.cart.items
    }
  },
  data () {
    return {
      overlay: false,
      categories: {
        data: [],
        total: 0
      },
      publicPath: process.env.VUE_APP_BASE_URL,
      logo: require('@/assets/logo-site-50.png'),
      year: new Date().getFullYear()
    }
  }
}
</script>
